<template>
  <el-dialog
    title="拼团推广"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    width="440px"
    @close="emitClose"
  >
    <div
      class="bcg-container"
      v-if="content.product"
    >
      <img
        :src="content.product.picture_url"
        alt=""
        srcset=""
        class="product_img"
      >
      <div class="price-wrap">
        <div class="wrap-left">
          <span class="left-span-1">拼团价: ¥{{content.prices.length?content.prices[0].price:0}}</span>
          <span class="left-span-2">￥{{content.product.price}}元</span>
        </div>
        <div class="wrap-right">
          <span>{{user_count}}人团</span>
        </div>
      </div>
      <div class="product-name">
        {{content.product.name}}
      </div>
      <div
        class="qrcode-img"
        id="qrcode"
        ref="qrcode"
      ></div>
    </div>
    <div class="down-div">
      <el-link
        type="primary"
        :underline="false"
        @click="draw"
      >下载图片</el-link>
      <el-link
        type="primary"
        :underline="false"
        @click="downloadQrcode"
      >下载二维码</el-link>
    </div>
    <div style="margin-top: 15px;">
      <el-input
        placeholder="请输入内容"
        v-model="product_url"
        class="input-with-select"
        readonly
      >
        <el-button
          slot="append"
          type="primary"
          @click="copyUrl"
        >复制链接</el-button>
      </el-input>
    </div>

    <div class="content_container">
      <vue-canvas-poster
        :painting="painting"
        @success="success"
        @fail="fail"
      ></vue-canvas-poster>
    </div>
  </el-dialog>
</template>

<script>
import { activityOne } from "@/api/operation";
import QRCode from "qrcodejs2"
export default {
  components: {

  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
    id: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      qrcode_url: null,
      imgUrl: "",//下载图片
      w: 320,
      h: 185,
      info: {},

      posterImg: '',//生成的海报
      painting: {},
      product_url: '',
      user_count: 0,
    };
  },
  mounted() { },
  activated() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchActivityDetail()
      }
    },
    content(val) {
      let url = "";
      if (this.content.product.type == 1) {
        url = `https://h5.kaoyanbox.com/course/detail/${this.content.product_id}`
      } else if (this.content.product.type == 4) {
        url = `https://h5.kaoyanbox.com/material/detail/${this.content.product_id}`
      } else if (this.content.product.type == 3) {
        url = `https://h5.kaoyanbox.com/read/detail/${this.content.product_id}`
      }
      this.product_url = url;
      this.$nextTick(() => {
        this.qrcode();
        setTimeout(() => {
          this.painting = {
            width: '400px',
            height: '636px',
            background: require('../../../assets/img/activity_bcg.png'),
            views: [
              {
                type: 'image',
                url: this.content.product.picture_url,
                css: {
                  left: '40px',
                  width: '320px',
                  height: '320px',
                  top: '112px',
                }
              },
              {
                type: 'text',
                text: `拼团价: ¥${this.content.prices.length ? this.content.prices[0].price : 0}`,
                css: {
                  width: '195px',
                  fontSize: "20px",
                  color: "#FE1F41",
                  bottom: '165px',
                  left: '40px',
                  fontFamily: 'PingFang SC'
                },
              }, {
                type: 'text',
                text: `￥${this.content.product.price}元`,
                css: {
                  width: '80px',
                  fontSize: "14px",
                  color: "#CCCCCC",
                  bottom: '165px',
                  left: '170px',
                  fontFamily: 'PingFang SC',
                  textDecoration: 'line-through',
                  textAlign: 'cneter',
                },
              }, {
                type: 'text',
                text: `${this.user_count}人团`,
                css: {
                  fontSize: "10px",
                  color: "#fff",
                  bottom: '170px',
                  right: '47px',
                  fontFamily: 'PingFang SC',
                  textAlign: 'cneter',
                },
              }, {
                type: 'text',
                text: `${this.content.product.name}`,
                css: {
                  width: '195px',
                  height: '120px',
                  fontSize: "16px",
                  color: "#333",
                  bottom: '110px',
                  left: '40px',
                  fontFamily: 'PingFang SC',
                  lineHeight: '24px',
                  fontWeight: '800',
                  textAlign: 'justify',
                },
              },
              {
                type: 'image',
                url: document.querySelectorAll('img')[2].currentSrc,
                css: {
                  right: '40px',
                  width: '88px',
                  height: '88px',
                  bottom: '56px'
                }
              },],
          }
        }, 800);
      });
    },
  },
  methods: {
    fetchActivityDetail() {
      activityOne({ id: this.id }).then((res) => {
        this.user_count = res.user_count
      });
    },
    emitClose() {
      document.querySelector("#qrcode").innerHTML = "";

      this.$emit("close");
    },
    qrcode() {
      console.log(this.product_url);
      let qrcode = new QRCode("qrcode", {
        width: 88, // 二维码宽度，单位像素
        height: 88, // 二维码高度，单位像素
        text: this.product_url, // 生成二维码的链接
      });

    },
    downloadQrcode() {
      let img = document.querySelectorAll('img')[2].currentSrc
      var a = document.createElement('a')
      a.download = 'qrcode'
      // 设置图片地址
      a.href = img;
      a.click();
    },
    copyUrl() {
      const input = document.createElement("textarea");
      input.setAttribute("id", "__mouse__position_input");
      input.value = this.product_url
      this.$copyText(input.value).then((e) => {
        this.$notify.success({
          title: "提示",
          message: "复制成功",
          type: "success",
        });
      });
    },
    draw() {
      var a = document.createElement('a')
      a.download = 'poster'
      // 设置图片地址
      a.href = this.posterImg;
      a.click();
    },
    success(src) {
      this.posterImg = src
    },
    fail(err) {
      alert(err)
    },
  },
};
</script>

<style lang="less" scoped>
.bcg-container {
  width: 400px;
  height: 636px;
  background-image: url("https://upload.kaoyanbox.net/e742bf45cc339ebcbb42e3eb63b8a6dc.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0px 40px;
  padding-top: 100px;
  position: relative;
  .product_img {
    width: 320px;
    height: 320px;
    border-radius: 6px;
    margin-top: 12px;
  }
  .price-wrap {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .wrap-left {
      .left-span-1 {
        font-size: 20px;
        color: #fe1f41;
        margin-right: 16px;
      }
      .left-span-2 {
        font-size: 14px;
        color: #cccccc;
        text-decoration: line-through;
      }
    }
    .wrap-right {
      width: 40px;
      text-align: center;

      span {
        font-size: 10px;
        color: #fff;
      }
    }
  }
  .product-name {
    position: absolute;
    bottom: 95px;
    width: 195px;
    min-height: 60px;
    font-size: 16px;
    font-weight: 800;
    line-height: 24px;
  }
  .qrcode-img {
    position: absolute;
    width: 88px;
    height: 88px;
    bottom: 64px;
    right: 40px;
  }
}
.top-div {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    display: block;
    font-family: PingFang SC;
    color: #ffffff;
    margin-bottom: 8px;
    &:nth-child(1) {
      font-size: 18px;
      font-weight: 800;
    }
    &:nth-child(2) {
      font-size: 40px;
      font-weight: 800;
      margin-bottom: 12px;
    }
    &:nth-child(3) {
      font-size: 14px;
      margin-bottom: 12px;
    }
    &:nth-child(4) {
      padding: 0px 32px;
      height: 24px;
      border: solid 1px #ffffff;
      font-size: 12px;
      border-radius: 4px;
      text-align: center;
      line-height: 22px;
    }
  }
}
.bottom-div {
  margin-top: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    display: block;
    margin-bottom: 24px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8d8d8d;
    opacity: 1;
  }
}
.down-div {
  margin-top: 16px;
  .el-link {
    font-size: 12px;
    margin: 0px 8px;
  }
}
</style>